<p-dialog [(visible)]="displayDialog" [breakpoints]="{ '960px': '75vw', '640px': '100vw' }" [style]="{ width: '50vw' }">
	<ng-template pTemplate="header">
		<div class="h3">Print check {{ checkNumber }}</div>
	</ng-template>
	<span class="p-float-label">
		<p-dropdown
			#printCheckSelection
			[options]="printerSelection"
			optionLabel="label"
			name="printCheckSelection"
			[(ngModel)]="printerSelected"
			[style]="{ width: '100%' }"
			appendTo="body"
			[autoDisplayFirst]="false"
			[virtualScroll]="true"
			virtualScrollItemSize="30"
			filter="true"
			filterBy="filterByProperties"
		></p-dropdown>
		<label for="printCheckSelection">Select Printer</label>
	</span>

	<ng-template pTemplate="footer">
		<app-record-control-footer
			cancelLabel="Cancel"
			(onCancelChange)="closeDialogChange.emit(true)"
			[hideDelete]="true"
			saveLabel="Print"
			(onSaveChange)="onPrintAction()"
		></app-record-control-footer>
	</ng-template>
</p-dialog>
